<template>
  <main class="privacy" v-html="renderedHtml"></main>
  <AppFooter />
</template>

<script>
import { marked } from "marked";
import AppFooter from "../components/AppFooter.vue";
import privacyFr from "../i18n/legal/privacy.fr.md";
import privacyEn from "../i18n/legal/privacy.en.md";
import privacyDe from "../i18n/legal/privacy.de.md";

const SOURCES = { fr: privacyFr, en: privacyEn, de: privacyDe };

export default {
  name: "PrivacyPolicy",
  components: {
    AppFooter,
  },
  computed: {
    renderedHtml() {
      const locale = this.$i18n.locale;
      const md = SOURCES[locale] || SOURCES.en;
      return marked.parse(md);
    },
  },
};
</script>

<!-- Layout + typography styles live in src/styles/legal-pages.css (imported globally
     in main.js) because the content is rendered via v-html (marked) and Vue scoped
     CSS does not reach those nodes. -->
